import { PlaybackBaseEventData } from './playback-base-event-data';

export class PlaybackErrorEventArgs extends PlaybackBaseEventData {
  errorCode: string;

  constructor(data: PlaybackErrorEventArgs) {
    super('playbackError', data as PlaybackBaseEventData);
    this.errorCode = data.errorCode;
  }
}
